import { render, staticRenderFns } from "./WorkHourDistChart.vue?vue&type=template&id=2db43446&scoped=true"
import script from "./WorkHourDistChart.vue?vue&type=script&lang=js"
export * from "./WorkHourDistChart.vue?vue&type=script&lang=js"
import style0 from "./WorkHourDistChart.vue?vue&type=style&index=0&id=2db43446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db43446",
  null
  
)

export default component.exports